"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureCardsListContainer = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var memoize = require("fast-memoize");
var sok_ui_1 = require("@caddigital/sok-ui");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
require("./index.scss");
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('FeatureList'), recompose_1.pure);
var resolveStatus = memoize(function (allStatus, status) {
    if (allStatus === 'FAILED' || status === 'FAILED') {
        return 'FAILED';
    }
    else if (allStatus === 'FETCHING' || status === 'FETCHING') {
        return 'FETCHING';
    }
    else if (allStatus === 'STANDBY' || status === 'STANDBY') {
        return 'STANDBY';
    }
    return 'FETCHED';
});
exports.FeatureCardsListContainer = enhance(function (props) {
    var status = resolveStatus(props.allFeaturesStatus, props.featuresStatus);
    switch (status) {
        case 'FAILED': {
            return React.createElement(GenericErrorMessage_1.default, null);
        }
        case 'FETCHED': {
            return (React.createElement("div", { className: "feature-cards-list" }, props.allFeatures.map(function (x) {
                var found = props.features.find(function (z) { return z.uuid === x.uuid; });
                return props.children(found || x);
            })));
        }
        default:
            return (React.createElement("div", { className: 'loading-features' },
                React.createElement(sok_ui_1.LoadingSpinner, null)));
    }
});
